<script lang="ts">
  import { client } from '$lib/api/Client';
  import { toastCustom, toastError } from '$utils/toasts';
  import Button from '../Button.svelte';
  import Modal from '../Modal.svelte';
  import SlideOver from '../SlideOver.svelte';
  import TextArea from '../TextArea.svelte';

  export let showBugReportModal = false;
  export let bugDescription = '';

  $: disabled = !bugDescription;

  const submitBugReport = async () => {
    try {
      await client.moderation.createBugReport(bugDescription);
      showBugReportModal = false;
      bugDescription = '';
      toastCustom({
        position: 'bottom-center',
        positive: true,
        contentFit: true,
        title: 'Thank you, your bug report has been submitted.',
      });
    } catch (error) {
      toastError(error);
    }
  };
</script>

<Modal bind:modalOpen={showBugReportModal} title="Report a Bug" size="md" class="hidden md:block">
  <div class="gap-y-lg flex flex-col">
    <p>
      Found a bug?
      <br /><br />We're sorry about that! This platform is brand-new, so thanks for bearing with us
      while we work out the kinks. Please describe the issue below, and we'll fix it as soon as
      possible.
    </p>
    <TextArea
      limitEnforced={false}
      placeholder={'Something went wrong...'}
      bind:value={bugDescription}
    />
    <div class="gap-x-lg flex items-center">
      <Button
        tertiary
        size="md"
        class="flex-1"
        on:click={() => {
          showBugReportModal = false;
        }}>Cancel</Button
      >
      <Button secondary size="md" {disabled} class="flex-1" on:click={submitBugReport}>
        Submit 🐞
      </Button>
    </div>
  </div>
</Modal>
<SlideOver
  title="Report a Bug"
  bind:slideOverOpen={showBugReportModal}
  class="block !h-screen md:hidden"
>
  <div class="gap-y-lg flex flex-col">
    <p>
      Found a bug?
      <br /><br />We're sorry about that! This platform is brand-new, so thanks for bearing with us
      while we work out the kinks. Please describe the issue below, and we'll fix it as soon as
      possible.
    </p>
    <TextArea
      limitEnforced={false}
      placeholder={'Something went wrong...'}
      bind:value={bugDescription}
    />
    <div class="gap-x-lg flex items-center">
      <Button
        tertiary
        size="md"
        class="flex-1"
        on:click={() => {
          showBugReportModal = false;
        }}>Cancel</Button
      >
      <Button secondary size="md" {disabled} class="flex-1" on:click={submitBugReport}>
        Submit 🐞
      </Button>
    </div>
  </div>
</SlideOver>
